import React from "react"

import { AttachmentType } from "shared/types/__generated__/graphql"

import { AttachmentLinkForm } from "features/attachment-links/ui/AttachmentLinkForm"

import { useProductPositionFormAttachmentsContext } from "../context/ProductPositionFormAttachmentsContext"
import { useProductPositionFormCoreContext } from "../contexts/ProductPositionFormCoreContext"

function getFormFieldName(attachment: AttachmentType) {
  return `attachments.${attachment.id}`
}

export const ProductPositionAttachmentsTab = React.memo(() => {
  const { attachments, linkedAttachments, attachmentCategories, onUpload } =
    useProductPositionFormAttachmentsContext()

  const { isReadonly } = useProductPositionFormCoreContext()

  return (
    <div className="product-position-form__tab-content product-position-form__tab-content--attachments">
      <AttachmentLinkForm
        attachments={attachments}
        linkedAttachments={linkedAttachments}
        getName={getFormFieldName}
        categories={attachmentCategories}
        isReadonly={isReadonly}
        onUpload={onUpload}
      />
    </div>
  )
})
